(function(){
  function lock(c,on){ if(on){ if(!c.hasAttribute('inert')) c.setAttribute('inert',''); } else if(c.hasAttribute('inert')) c.removeAttribute('inert'); }
  function apply(g){
    var later=g.classList.contains('pdc-later');
    [].forEach.call(g.children,function(c){
      if(c.classList.contains('group__heading')){
        [].forEach.call(c.children,function(k){
          if(k.matches('h2')||k.querySelector('h2')){
            /* kop blijft leesbaar, maar velden in dezelfde wrapper (bijv. aantal) gaan ook op slot */
            [].forEach.call(k.querySelectorAll('input,button,select,textarea,a[href],label'),function(f){ if(f.querySelector('h2')||f.matches('h2')) return; lock(f,later); });
            return;
          }
          lock(k,later);
        });
      } else lock(c,later);
    });
    g.setAttribute('aria-disabled',later?'true':'false');
  }
  function groepen(){ return [].slice.call(document.querySelectorAll('.calculator .main-group-sec > .group')); }
  function init(){
    var gs=groepen(); if(!gs.length) return false;
    gs.forEach(function(g){
      apply(g);
      new MutationObserver(function(){apply(g)}).observe(g,{attributes:true,attributeFilter:['class'],childList:true,subtree:true});
    });
    /* gewenste stand direct afdwingen als iets anders de klasse wijzigt, zodat er niets flikkert */
    gs.forEach(function(g,i){
      if(i<2) return;
      new MutationObserver(function(){ afdwingen(); }).observe(g,{attributes:true,attributeFilter:['class']});
    });
    return true;
  }
  function klaar(){ setTimeout(function(){ document.body.classList.remove('pdc-boot'); },200); }
  var n=0,t=setInterval(function(){ if(init()){ clearInterval(t); klaar(); } else if(++n>40){ clearInterval(t); klaar(); } },150);

  /* rustiger scrollen naar de volgende stap: onder de kop en niet voorbij het einde van de calculator */
  var orig=window.scrollTo.bind(window);
  window.scrollTo=function(o){
    try{
      if(o&&typeof o==='object'&&typeof o.top==='number'&&o.behavior!=='instant'&&document.body.classList.contains('pdc')){
        var m=document.querySelector('.calculator main'), top=o.top-116;
        if(m){ var lim=m.getBoundingClientRect().bottom+window.pageYOffset-window.innerHeight+60; top=Math.min(top,lim); }
        if(top<=window.pageYOffset) return;
        var c={}; for(var k in o) c[k]=o[k]; c.top=top; return orig(c);
      }
    }catch(e){}
    return orig.apply(window,arguments);
  };

  function num(v){return parseFloat(String(v).replace(',','.'))||0}
  function vals(){ return ['length','width','height','qq_qty'].map(function(id){var e=document.getElementById(id);return e?String(e.value).trim():''}).join('|'); }
  function compleet(){
    return ['length','width','height','qq_qty'].every(function(id){var e=document.getElementById(id); if(!e) return false; if(id==='height'&&!e.offsetParent) return true; return num(e.value)>0});
  }
  function bezig(){
    return [].some.call(document.querySelectorAll('.sidebar_loader'),function(e){return e.style.display&&e.style.display!=='none'}) || document.body.classList.contains('pdc-loading');
  }

  /* stap 2 is klaar zodra alle maten ingevuld zijn en binnen de grenzen van het gekozen type vallen; geen Enter nodig */
  function typeNu(){ var r=document.querySelector('input[name=main_box_type]:checked'); return r?r.value:''; }
  function specNu(){ var s=null; try{ s=specifications[typeNu()]; }catch(e){} return s; }
  var NAAM={length:'lengte',width:'breedte',height:'hoogte'};
  /* eerste veld dat buiten de grenzen valt: {id, dir} of null */
  function fouteMaat(){
    var spec=specNu();
    var ids=['length','width','height'];
    for(var i=0;i<ids.length;i++){
      var id=ids[i], e=document.getElementById(id); if(!e) return {id:id,dir:'klein'};
      if(id==='height'&&!e.offsetParent) continue;
      var v=num(e.value); if(!(v>0)) return {id:id,dir:'leeg'};
      if(spec&&spec[id]){ if(v<spec[id].min) return {id:id,dir:'klein'}; if(v>spec[id].max) return {id:id,dir:'groot'}; }
    }
    return null;
  }
  function matenGeldig(){ return !fouteMaat(); }

  /* foutmelding noemt het juiste veld en de juiste richting */
  var orgTekst=new WeakMap();
  function meldingTekst(f){
    if(!f||f.dir==='leeg') return;
    [].forEach.call(document.querySelectorAll('.calculator .error_msg_input'),function(m){
      var w=document.createTreeWalker(m,NodeFilter.SHOW_TEXT,null), nd;
      while((nd=w.nextNode())){
        if(!orgTekst.has(nd)) orgTekst.set(nd,nd.nodeValue);
        var o=orgTekst.get(nd);
        var nw=o.replace(/\blengte\b/g,NAAM[f.id]).replace(/te klein/g,'te '+f.dir);
        if(nd.nodeValue!==nw) nd.nodeValue=nw;
      }
    });
  }
  /* schermlezers lezen meldingen voor */
  function aria(){
    [].forEach.call(document.querySelectorAll('.calculator .error_msg_input,.calculator #error_mess_qty,.calculator #error_message_bedrukt'),function(m){
      if(m.getAttribute('role')!=='alert'){ m.setAttribute('role','alert'); m.setAttribute('aria-live','assertive'); }
    });
  }

  var sig=null, last='', auto='', prev=vals(), chg=Date.now(), wasFout=false, gescrold='', okSinds=0, naar4='', laatsteType='', aangeraakt=false;
  document.addEventListener('click',function(ev){
    var g=groepen(); if(g.length<3) return;
    if(g[2].contains(ev.target)&&ev.target.closest('label,input')){ aangeraakt=true; }
  },true);
  var wens={g2:true,g3:true,g4:true};
  function prijs(){ var e=document.getElementById('total_amount_price'); return e?e.textContent.trim():''; }
  function foutZichtbaar(){ return [].some.call(document.querySelectorAll('.calculator .error_msg_input'),function(e){return e.offsetHeight>0}); }
  function bereken(){
    var p=prijs(), v=vals();
    var fout=foutZichtbaar();
    var priced=num(p)>0&&document.body.classList.contains('pdc-priced');
    var stale=priced&&sig!==null&&v!==sig;
    var ok=matenGeldig()&&!fout;
    wens={g2:!ok,g3:!ok,g4:fout||stale||!priced||!ok};
    return {fout:fout,stale:stale,ok:ok,priced:priced,v:v,p:p};
  }
  function afdwingen(){
    var g=groepen(); if(g.length<5) return;
    [[2,wens.g2],[3,wens.g3],[4,wens.g4]].forEach(function(x){
      if(g[x[0]].classList.contains('pdc-later')!==x[1]) g[x[0]].classList.toggle('pdc-later',x[1]);
    });
  }
  function tick(){
    var p=prijs(), v=vals();
    if(v!==prev){ prev=v; chg=Date.now(); }
    if(p!==last){ last=p; clearTimeout(tick.t); tick.t=setTimeout(function(){ sig=vals(); },400); }
    var b=bereken(), fout=b.fout, stale=b.stale, ok=b.ok;
    var fm=fouteMaat(); document.body.classList.toggle('pdc-leeg',!!(fm&&fm.dir==='leeg'));
    document.body.classList.toggle('pdc-fout',fout||stale);
    var g=groepen();
    if(g.length>4){
      var t=typeNu(); if(t!==laatsteType){ laatsteType=t; aangeraakt=false; }
      afdwingen();
      if(fout){ meldingTekst(fouteMaat()); }
      if(!fout&&wasFout){ document.dispatchEvent(new Event('input',{bubbles:true})); }
      /* vanzelf naar stap 3 zodra de maten kloppen en de bezoeker even stopt met typen */
      var sleutel=t+'|'+['length','width','height'].map(function(id){var e=document.getElementById(id);return e?e.value:''}).join('x');
      if(ok&&Date.now()-chg>900&&gescrold!==sleutel){
        gescrold=sleutel;
        var a=document.activeElement;
        if(a&&/^(length|width|height)$/.test(a.id)){
          var top=g[2].getBoundingClientRect().top;
          if(!(top>60&&top<window.innerHeight*0.4)) window.scrollTo({top:window.pageYOffset+top-24,behavior:'smooth'});
          g[2].classList.remove('pdc-flash'); void g[2].offsetWidth; g[2].classList.add('pdc-flash');
        }
      }
      if(!ok){ gescrold=''; okSinds=0; naar4=''; }
      else {
        if(!okSinds) okSinds=Date.now();
        /* 5 seconden niets gekozen in stap 3: door naar stap 4 */
        if(!aangeraakt&&Date.now()-okSinds>5900&&naar4!==sleutel&&gescrold===sleutel){
          naar4=sleutel;
          var t4=g[3].getBoundingClientRect().top;
          if(!(t4>60&&t4<window.innerHeight*0.4)) window.scrollTo({top:window.pageYOffset+t4-24,behavior:'smooth'});
          g[3].classList.remove('pdc-flash'); void g[3].offsetWidth; g[3].classList.add('pdc-flash');
        }
      }
    }
    wasFout=fout;
    aria();
    if(stale&&!fout&&!bezig()&&compleet()&&auto!==v&&Date.now()-chg>1200){
      auto=v; var bt=document.getElementById('calc_pp_ctm'); if(bt&&bt.offsetHeight>0) bt.click();
    }
  }
  setInterval(tick,300);
  /* direct na invoer opnieuw bepalen (geen wachttijd, dus geen flikkering) */
  ['input','change','click','keyup'].forEach(function(e){ document.addEventListener(e,function(){ bereken(); afdwingen(); setTimeout(function(){ bereken(); afdwingen(); },0); setTimeout(tick,80); },true); });
  /* melding over bedrukking weg zodra de bezoeker (opnieuw) Geen bedrukking kiest */
  document.addEventListener('click',function(ev){
    var l=ev.target.closest&&ev.target.closest('label'); var i=l&&l.querySelector('input#geen_bedru'); if(!i) return;
    setTimeout(function(){ var m=document.getElementById('error_message_bedrukt'); if(m&&m.textContent.trim()){ m.innerHTML=''; m.dataset.pdc=''; } },150);
  },true);
})();
